'use strict';

/**
 * Format an amount of Kilos into locale wheight using a Weight model.
 * @param {String|Number} quantity - Quantity to be from kilos to local weight.
 * @param {Object} [weightConfig = Utils.weight] - Weight model to be used. Param is optional
 * @return {String} The weight properly formatted according to the Weight model.
 */
Odigeo.Utils.formatKilosToLocaleWeight = function(quantity, weightConfig) {
    weightConfig = weightConfig || Odigeo.Utils.Weight;
    quantity = weightConfig.roundFunction(Math.abs((+quantity || 0) * weightConfig.conversionRate));
    const values = [quantity];
    weightConfig.unitPosition === 'front' ? values.unshift(weightConfig.unitSymbol) : values.push(weightConfig.unitSymbol);

    return values.join('');
};
